export class PasswordReset {
    userEmail: string;
    password: string;
    userID :number;
}